export enum MailboxStatus {
  SYNCING,
  SYNCED,
  SYNC_FAILED,
  CANCELLED,
}
